import { Skeleton } from 'src/shared/components/ui/miscellaneous/skeleton'

export const NotificationSidebarItemSkeleton = () => {
  return (
    <div className="w-full px-5 py-3">
      <div className="flex items-start gap-3">
        <div className="relative">
          <Skeleton className="size-8 rounded-full" />
        </div>
        <div className="flex flex-col items-start justify-between gap-1">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-16" />
        </div>
      </div>
    </div>
  )
}

export const NotificationSidebarSkeleton = () => {
  return (
    <div className="flex flex-col">
      {[...Array(5)].map((_, i) => (
        <NotificationSidebarItemSkeleton key={i} />
      ))}
    </div>
  )
}
